import { render, staticRenderFns } from "./FormatReferenceTreeAddFormatTreeDialog.vue?vue&type=template&id=54ec2f9c&scoped=true&"
import script from "./FormatReferenceTreeAddFormatTreeDialog.vue?vue&type=script&lang=ts&"
export * from "./FormatReferenceTreeAddFormatTreeDialog.vue?vue&type=script&lang=ts&"
import style0 from "./FormatReferenceTreeAddFormatTreeDialog.vue?vue&type=style&index=0&id=54ec2f9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ec2f9c",
  null
  
)

export default component.exports